import { stateType } from "../../state";

export function FAQ({ state }: stateType) {
  return <div>FAQ</div>;
}
